import IInputProps, { ISlimInputProps } from "./IInputProps";
import InputContainer, { InputContainerRow } from "./InputContainer";

export default <T,>({ name, label, formik, placeholder, onChange }: IInputProps<T, string>) => {
    return (
        <InputContainer label={label} name={name} formik={formik}>
            <TextInputSlim name={name} formik={formik} placeholder={placeholder} onChange={onChange} />
        </InputContainer>
    );
}

export const StringInputRow = <T,>({ name, label, formik, placeholder, onChange }: IInputProps<T, string>) => {
    return (
        <InputContainerRow name={name} label={label} formik={formik}>
            <TextInputSlim name={name} formik={formik} placeholder={placeholder} onChange={onChange} />
        </InputContainerRow>
    );
}

export const TextInputSlim = <T,>({ name, formik, placeholder, onChange }: ISlimInputProps<T, string>) => {
    return (
        <textarea
            name={name as string}
            value={formik.values[name] as string || ""}
            onChange={e => {
                const value = e.target.value || null;
                formik.setValues({
                    ...formik.values,
                    [name]: value,
                    ...onChange ? onChange(value) : {},
                });
            }}
            onBlur={formik.handleBlur}
            placeholder={placeholder}
        />
    );
}